/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { RadioButtons } from '@locus-taxy/neo-ui';

import { rankWith, uiTypeIs } from '@jsonforms/core';
import useEnumProps from '../util/useEnumProps';

type Props = {};

const EnumRadioControl = (props: Props): React.Node => {
    const { handleChange, path, schema } = useEnumProps(props);

    const opts = React.useMemo(() => {
        const values = schema.enum || schema.items.enum;
        return values.map(value => ({
            key: value.key,
            value: value.value
        }));
    }, [schema]);

    return (
        <RadioButtons
            size="medium"
            label={''}
            options={opts}
            onChange={option => {
                handleChange(path, option);
            }}
            row
        />
    );
};

export default EnumRadioControl;

export const enumRadioControlTester: any = rankWith(
    1,
    uiTypeIs('EnumRadioControl')
);
